export function fmtShortDate(d: string): string {
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-AU', { month: 'short', day: 'numeric' });
}

export function fmtMonthHeader(d: string): string {
  const dt = new Date(d + 'T00:00:00');
  return dt.toLocaleDateString('en-AU', { month: 'short', year: 'numeric' });
}
